import { Trans, useTranslation } from "react-i18next"
import { Link, Text } from "@oysterhr/ui"
import { HOW_TO_SET_UP_DIRECT_DEBIT_LINK } from "../../../../../utils"
import { SepaAdvisorStep } from "../../utils"
import { UrlQueryParamContext } from "@oysterhr/quarantine"
import { useContext } from "react"

export const SepaAdvisor = ({ newFlow }: { newFlow?: boolean }) => {
  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage/SepaFlow")
  const { params } = useContext(UrlQueryParamContext)
  const step = (params?.page ?? "1") as SepaAdvisorStep

  return (
    <span className="text-base leading-normal text-black">
      <div>
        <Text className="font-semibold">{t(`pearl.steps.${newFlow ? "new" : "old"}.${step}`)}</Text>
        <Text className="mt-4">
          <Trans
            t={t}
            i18nKey={"pearl.footer"}
            components={{
              a: (
                <Link
                  to={HOW_TO_SET_UP_DIRECT_DEBIT_LINK}
                  target="_blank"
                  className="inline text-base font-normal underline"
                />
              ),
            }}
          />
        </Text>
      </div>
    </span>
  )
}
